import { render, staticRenderFns } from "./DialogWarningIcon.vue?vue&type=template&id=2ff8a164"
import script from "./DialogWarningIcon.vue?vue&type=script&lang=ts"
export * from "./DialogWarningIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports